import styled from 'styled-components'

const FaqContainer = styled.section`
  background: linear-gradient(
    345.92deg,
    rgba(208, 230, 165, 0.8) 2.63%,
    rgba(134, 227, 206, 0.8) 96.81%
  );
  padding: 5vw;
  font-family: 'Inter', sans-serif;
  min-height: 120px;
  width: 100%;
  min-height: 100vh;
`
const FrequentlyAskedQuestionsHeading = styled.h2`
  color: rgba(13, 21, 54, 0.8);
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 2.7rem;
  line-height: 120%;
  text-align: center;
  @media (max-width: 700px) {
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 120%;
    color: rgba(13, 21, 54, 0.8);
  }
`
const AccordionContainer = styled.div`
  margin: auto;
  max-width: 800px;
  transition: all 0.2s;
  color: rgba(13, 21, 54, 0.65);
  @media (max-width: 600px) {
    margin: auto;
  }
`
const Accordion = styled.div`
  margin: 16px auto;
  color: rgba(13, 21, 54, 0.65);
`
const AccordionText = styled.div`
  max-height: 0;
  overflow: hidden;
  color: var(--Text500);
  transition: max-height 0.25s ease-out;
  color: rgba(13, 21, 54, 0.65);
  &::first-letter {
    text-transform: capitalize;
  }
`
const AccordionBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  color: rgba(13, 21, 54, 0.7);
  &::first-letter {
    text-transform: capitalize;
  }
  &:after {
    content: '+';
    color: rgba(13, 21, 54, 0.7);
    font-size: 20px;
    margin-left: 8px;
    float: right;
  }
  &.open:after {
    content: '-';
    color: rgba(13, 21, 54, 0.7);
  }
`
const FAQSectionHead = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 200%;
  color: rgba(13, 21, 54, 0.65);
  margin: 24px auto;
  max-width: 800px;
  @media (max-width: 700px) {
    margin-top: 24px;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 200%;
    color: rgba(13, 21, 54, 0.8);
    font-family: 'Inter', sans-serif;
  }
`
export {
  FaqContainer,
  FrequentlyAskedQuestionsHeading,
  Accordion,
  AccordionBtn,
  AccordionContainer,
  AccordionText,
  FAQSectionHead,
}
